import { render, staticRenderFns } from "./UpcommingCampaignsComponent.vue?vue&type=template&id=b4a0b2ee"
import script from "./UpcommingCampaignsComponent.vue?vue&type=script&lang=js"
export * from "./UpcommingCampaignsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports